module.exports = __webpack_public_path__ + "static/img/icon_3.4c4af7f9.png";